// Build stamp. The committed file is the placeholder; the pipeline overwrites it
// with the build number, short commit SHA and the build time computed once per
// run and shared with the API (see azure-pipelines.yml). A local build must
// never look like a release.
export const version = {
  build: '2026.11.03.1',
  commit: 'a92ae1f',
  builtAt: '2026-11-03T13:25Z',
} as const;
